var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-create-contract"},[_c('FormCreateContract',{on:{"saveContractDone":_vm.handleOpenModalDocument}}),_c('ModalDocument',{attrs:{"contractId":_vm.contractId,"billId":-1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }